import { useEffect } from "react";

const SEO_DATA = {
  "bathroom-remodeling": {
    title: "Full Bathroom Remodel Albuquerque NM | Prime Baths of New Mexico",
    description: "Complete bathroom remodeling in Albuquerque, Rio Rancho & Santa Fe. Custom vanities, tile, flooring & fixtures. 4.9★ rated, 250+ reviews. Get $1500 off! Call (505) 472-7064.",
    keywords: "bathroom remodel Albuquerque, full bathroom renovation New Mexico, bathroom contractor Rio Rancho, Santa Fe bathroom remodeling, custom vanity installation"
  },
  "tub-shower-conversions": {
    title: "Tub to Shower Conversion & Shower to Tub | Albuquerque NM | Prime Baths",
    description: "Tub-to-shower & shower-to-tub conversions in Albuquerque & New Mexico. Walk-in showers, soaking tubs, glass doors, safety features. 1-day install. 4.9★ rated. Get $1500 off! Call (505) 472-7064.",
    keywords: "tub to shower conversion Albuquerque, shower to tub conversion New Mexico, bathtub removal, walk-in shower installation, shower conversion Rio Rancho, tub conversion Santa Fe, bathroom conversion"
  },
  "walk-in-tubs": {
    title: "Walk-In Tubs Albuquerque NM | Prime Baths of New Mexico",
    description: "Walk-in tub installation in Albuquerque & New Mexico. Safe, accessible bathing for seniors. Low step-in, grab bars, hydrotherapy jets. 4.9★ rated. Get $1500 off! Call (505) 472-7064.",
    keywords: "walk-in tub Albuquerque, accessible bathtub New Mexico, senior bathtub installation, walk-in tub Rio Rancho, therapeutic tub Santa Fe, handicap tub, ADA compliant bathtub"
  },
  "scheduling": {
    title: "Schedule Your Free Consultation | Prime Baths of New Mexico",
    description: "Book your free in-home bathroom consultation with Prime Baths of New Mexico. No obligation estimates. Available appointments at 10am, 2pm, 4pm. Call (505) 472-7064.",
    keywords: "bathroom consultation Albuquerque, free bathroom estimate New Mexico, Prime Baths appointment"
  }
};

export const SEOHead = ({ page = "bathroom-remodeling" }) => {
  useEffect(() => {
    const seo = SEO_DATA[page] || SEO_DATA["bathroom-remodeling"];
    
    // Update title
    document.title = seo.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", seo.description);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", seo.keywords);
    }
    
    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute("content", seo.title);
    }
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute("content", seo.description);
    }
    
    // Update Twitter tags
    let twitterTitle = document.querySelector('meta[property="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", seo.title);
    }
    
    let twitterDescription = document.querySelector('meta[property="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", seo.description);
    }
  }, [page]);

  return null;
};

export default SEOHead;
